import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { InfinteScroll } from '../../components/common/InfinteScroll';
import { Loading } from '../common/Loading';
import { SiteSurveyConstant } from '../../actions/constants/SiteSurveyConstant';
import { SiteSurveyAction } from '../../actions/SiteSurveyAction';
import SurveyCard from './SurveyCard';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Translate as t } from '../../config/Translate';
import { readVersionedJSON, writeVersionedJSON } from '../../lib/sessionStorageVersioned';

const FILTER_KEY = 'reportManager:surveyFilter:v1';
const MY_TAB = 'survey';
const LOADED_TAB_KEY = 'reportManager:loadedTab';

const SurveyList = ({ GetSiteSurveyList, items, totalCount, isLoading, Clear, showAS = false, callbackAS, fixList = null, fix = false }) => {
	//const [ t, i18n ] = useTranslation();
	const savedFilter = useMemo(() => {
		const f = readVersionedJSON(FILTER_KEY, { incomplete: 'in', search: '' });
		return (f && typeof f === 'object' && !Array.isArray(f)) ? f : { incomplete: 'in', search: '' };
	}, []);

	const [target, setTarget] = useState(null);
	const [page, setPage] = useState(1);
	const [incomplete, setIncomplete] = useState(savedFilter.incomplete ?? 'in');
	const [itemperpage, setItemPage] = useState(30);
	const [search, setSearch] = useState(savedFilter.search ?? '');
	const [data, setData] = useState([]);
	const [newSearch, setNewSearch] = useState(false);
	const firstIncompleteRef = useRef(true);
	const pageRef = useRef(page);
	pageRef.current = page;

	useEffect(() => {
		if(fixList){
			setData(fixList || []);
		}
	}, [fixList]);

	useEffect(() => {
		if(!fix)
			setData(items || []);
	}, [items]);

	const Reload = () => {
		if(!fix){
			if (page === 1) Clear();
			GetSiteSurveyList({
				itemperpage: itemperpage,
				searchCols: ["siteSitename"],
				searchKey: search,
				page: page,
				match: { isSubmit: incomplete != "in" },
				sort: { createDate: -1 }
			}, true);
		}
	}

	const didFirstRef = useRef(false);
	useEffect(() => {
		if (fix) return;
		if (!didFirstRef.current) {
			didFirstRef.current = true;
			let loadedTab = null;
			try { loadedTab = sessionStorage.getItem(LOADED_TAB_KEY); } catch (e) {}
			const hasCache = items && items.length > 0;
			if (loadedTab === MY_TAB && hasCache) {
				return; // 리스트→View→복귀: redux 캐시 유지, 재조회 skip
			}
			try { sessionStorage.setItem(LOADED_TAB_KEY, MY_TAB); } catch (e) {}
		}
		Reload();
	}, [page]);

	useEffect(() => {
		if (firstIncompleteRef.current) { firstIncompleteRef.current = false; return; }
		if (pageRef.current === 1) Reload(); else setPage(1);
	}, [incomplete]);

	const isEnd = () => { return totalCount <= page * itemperpage; }

	InfinteScroll({
		target,
		onIntersect: ([{ isIntersecting }]) => {
			if (isIntersecting && !isLoading && !isEnd()) {
				setPage(page + 1);
			}
		}
	});

	const submit = () => {
		if (!fix) writeVersionedJSON(FILTER_KEY, { incomplete, search }); // 필터·검색어 영속(#345), fix(정적 목록) 제외
		callbackAS();
		if (pageRef.current === 1) Reload(); else setPage(1);
	}

	const getCss = (i) => i == incomplete ? "btn btn-primary" : "btn btn-outline-primary";

	return (
		<>
			{data?.map(item => <div key={item._id}> <SurveyCard item={item} /> </div>)}
			{isLoading && <Loading />}

			<Modal show={showAS} onHide={() => callbackAS()} className="action-sheet">
				<Modal.Header>
					<h5 className="modal-title">{t('common.label.option')}</h5>
				</Modal.Header>
				<Modal.Body className=" p-2">
					<div className="form-group basic">
						<div className="input-wrapper mb-2">
							<label className="label">Filter</label>
							<div className="btn-group btn-block">
								<button className={getCss("in")} onClick={() => setIncomplete("in")}>{t('common.status.incomplete')}</button>
								<button className={getCss("com")} onClick={() => setIncomplete("com")}>{t('common.button.complete')}</button>
							</div>
						</div>
						<div className="input-wrapper">
							<label className="label">{t('common.button.search')}</label>
							<input type="text" value={search} className="form-control" onChange={(e) => setSearch(e.target.value)} />
						</div>
					</div>
					<button className="btn btn-block btn-primary" data-bs-dismiss="modal" onClick={() => submit()}>{t('common.button.submit')}</button>

				</Modal.Body>
			</Modal>

			<div ref={setTarget} className='last-item' />
		</>
	);
};

const mapState = (state) => {
	const items = state.SiteSurveyReducer.siteSurveys;
	const totalCount = state.SiteSurveyReducer.totalSiteSurveyCount;
	const isLoading = state.SiteSurveyReducer.isLoading;

	return { items, totalCount, isLoading };
};

const mapDispatch = (dispatch) => ({
	GetSiteSurveyList: (filter, append) => dispatch(SiteSurveyAction.GetSiteSurveyList(filter, append)),
	Clear: () => dispatch({ type: SiteSurveyConstant.CLEAR }),
});

export default connect(mapState, mapDispatch)(SurveyList);